import { render, staticRenderFns } from "./OsStatisticsCardGeneral.vue?vue&type=template&id=c6001ca2&scoped=true"
import script from "./OsStatisticsCardGeneral.vue?vue&type=script&lang=ts"
export * from "./OsStatisticsCardGeneral.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6001ca2",
  null
  
)

export default component.exports